<template>
  <div style="position: relative; width: 100%; height: auto">
    <div class="main-news-wrapper">
      <div class="inner" ref="inner">
        <template v-if="latestNews.length > 0">
          <transition-group name="fade" appear>
            <template v-for="(list, index) in latestNews" :key="index">
              <component
                :is="
                  list.length !== pageSize
                    ? 'universalList'
                    : index - 1 === -1
                    ? 'defaultBar'
                    : `bar${(index - 1).toString().substr(-1)}`
                "
                :list="list"
                transition-mode="out-in"
              />
            </template>
          </transition-group>
        </template>
      </div>
      <div
        v-if="show.spinner"
        style="
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 44px 0;
        "
        :style="{ height: latestNews.length > 0 ? 'unset' : '80vh' }"
      >
        <div class="lds-spinner">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed, reactive, watch } from "vue";
import AdditionalBar from "@/components/AdditionalBar";
import MainBar from "@/components/world/MainBar.vue";
import FirstBar from "@/components/world/FirstBar";
import SecondBar from "@/components/world/SecondBar";
import ThirdBar from "@/components/world/ThirdBar";
import FourthBar from "@/components/world/FourthBar";
import FivthBar from "@/components/world/FivthBar";
import { useStore } from "vuex";
import { useInfiniteScroll } from "@/utils/infiniteScroll";
import { useLanguage } from "@/utils/language";

export default {
  components: {
    defaultBar: MainBar,

    universalList: AdditionalBar,

    bar0: FirstBar,
    bar1: SecondBar,
    bar2: ThirdBar,
    bar3: FourthBar,
    bar4: FivthBar,

    bar5: FirstBar,
    bar6: SecondBar,
    bar7: ThirdBar,
    bar8: FourthBar,
    bar9: FivthBar
  },
  setup() {
    const store = useStore();
    const inner = ref(null);
    const show = reactive({
      spinner: true
    });

    const { i18n } = useLanguage();

    const scrollEnd = () => {
      show.spinner = false;
    };

    const pageSize = 7;

    const { startInfiniteScroll, loadData } = useInfiniteScroll({
      wrapper: inner,
      retrieve: (load, cb) => {
        store.dispatch("getLatestNews", {
          pageSize,
          cb: () => cb(),
          category: 'world',
          load
        });
      },
      newsCount: computed(() => store.getters.newsCount),
      currentPage: computed(() => store.getters.currentPage),
      pageSize,
      scrollEnd
    });

    const refreshData = () => {
      store.commit("flushArticleState");

      show.spinner = true;
      startInfiniteScroll();
      loadData();
    };

    refreshData()

    watch(() => i18n.global.locale.value, refreshData);

    return {
      inner,
      show,
      pageSize,
      latestNews: computed(() => store.getters.latestNews)
    };
  }
};
</script>

<style lang="scss" scoped>
.main-news-wrapper {
  --color-category: rgba(255, 255, 255, 0.7);
  width: 100%;
  position: relative;
  color: #fff;
  font-size: 16px;
  @media screen and (max-width: 1200px) {
    font-size: 12px;
  }
@media screen and (max-width: 992px) {
    font-size: 14px;

}

  .inner {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 3.125rem;
    background-color: #447562;
  }
}
</style>
